<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row mt-1">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="company">
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Dénomination sociale"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input formControlName="name" type="text" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Forme juridique"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <mat-select formControlName="legalForm">
                        @for (legalForm of companyLegalForms; track legalForm) {
                          <mat-option [value]="legalForm.id">
                            {{ legalForm.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Représentant légal"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input formControlName="representative" type="text" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Fonction du représentant légal"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <mat-select formControlName="representativeFunction">
                        @for (
                          representativeOption of representativeOptions;
                          track representativeOption
                        ) {
                          <mat-option [value]="representativeOption.id">
                            {{ representativeOption.value }}
                          </mat-option>
                        }
                      </mat-select>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12 p-0">
                    <pr-input-column label="Email" [derrors]="derrors">
                      <input formControlName="email" type="text" />
                      <pr-icon name="email"></pr-icon>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12 p-0">
                    <pr-input-date
                      label="Date de création"
                      formControlName="creationDate"
                      [derrors]="derrors"
                      [isDefault]="false"
                    ></pr-input-date>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Régime fiscal"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <mat-select formControlName="taxSystem">
                        @for (
                          companyTaxSystem of taxSystems;
                          track companyTaxSystem
                        ) {
                          <mat-option [value]="companyTaxSystem.id">
                            {{ companyTaxSystem.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </pr-input-column>
                  </div>
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Résidence fiscale"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <mat-select formControlName="taxResidence">
                        @for (contry of countries; track contry) {
                          <mat-option [value]="contry.id">
                            {{ contry.value }}
                          </mat-option>
                        }
                      </mat-select>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Capital social"
                      [derrors]="derrors"
                      [isDefault]="false"
                      suffix="€"
                    >
                      <input formControlName="socialCapital" type="number" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Valorisation"
                      [derrors]="derrors"
                      [isDefault]="false"
                      suffix="€"
                    >
                      <input formControlName="valorisation" type="number" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Code SIRET"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input formControlName="codeSiret" type="text" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="TVA"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input formControlName="tva" type="text" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Numéro immatriculation RCS"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input formControlName="rcs" type="text" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Lieu immatriculation RCS"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input
                        formControlName="lieuImmatriculationRcs"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Code APE"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input formControlName="codeAPE" type="text" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-column
                      label="Secteur d'activité"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <mat-select formControlName="activitySector">
                        @for (
                          companyActivitySector of companyActivitySectors;
                          track companyActivitySector
                        ) {
                          <mat-option [value]="companyActivitySector.id">
                            {{ companyActivitySector.value }}
                          </mat-option>
                        }
                      </mat-select>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-{{ col }} p-0 ">
                    <pr-input-radio
                      formControlName="societeCotee"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Société côtée ?"
                    >
                    </pr-input-radio>
                  </div>
                  @if (owner.get('company').get('societeCotee').value) {
                    <div class="col-md-{{ col }} p-0 ">
                      <pr-input-column
                        label="Société côté sur quel marché ?"
                        [derrors]="derrors"
                        [isDefault]="false"
                      >
                        <input
                          formControlName="societeCoteeMarche"
                          type="text"
                        />
                      </pr-input-column>
                    </div>
                  }
                </div>
                @if (
                  parameters?.advisor?.legalEntities?.[0]?.name == 'CRISTALIS'
                ) {
                  <div class="row custom-radio">
                    <div class="col-md-{{ col }}">
                      <pr-input-radio
                        formControlName="isPublicSiret"
                        columns="3"
                        [toggle]="true"
                        [isDefault]="false"
                        label="Votre code SIRET doit-il être publique ?"
                      >
                      </pr-input-radio>
                    </div>
                  </div>
                }
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
